import './style.scss';
import React, { useEffect, useState } from 'react';
import { List } from 'views/components/organisms/list';
import { getNoticeHeaderShowList } from 'views/constants/const/Notices';
import { GetNotificationListQueryVariables, useGetNotificationListQuery } from 'views/utils/graphql/graphql';
import { useGetNotificationList } from './hooks/useGetNotificationList';
import { BodyShowList } from 'views/components/molecules/listBody';
import { createBodyShowLists } from './function/createBodyShowList';
import { Pagination } from 'views/components/atoms/pagination';
import { calcTotalPage } from 'views/utils/calc/pagination';
import { ModalBase, ModalStyle } from 'views/components/atoms/modal';
import { NoticeDetail } from '../noticeDetail';
import { PageLocationSP } from 'views/components/atoms/pageLocation';
import { Tabs } from 'views/components/atoms/tabs';
import { NotificationDeliverTargetType } from 'views/constants/enums/Notice';

export const Notice = () => {
  const [selectedDeliveryType, setSelectedDeliveryType] = useState<number>(NotificationDeliverTargetType.All);
  const PAGE_COUNT = 30;
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const [noticeId, setNoticeId] = useState<string>('');

  const getNewNoticeListVariables = () => {
    const param: GetNotificationListQueryVariables = {
      count: PAGE_COUNT,
      page: currentPage,
      deliveryTarget: selectedDeliveryType,
      onlyNotConfirmed: false,
    };
    return param;
  };
  const { noticeList, getNoticeList, setNoticeListVariables } = useGetNotificationList(getNewNoticeListVariables());

  const [notConfirmedNoticeList, getNotConfirmedNoticeList] = useGetNotificationListQuery({
    variables: {
      count: 1,
      page: 1,
      deliveryTarget: 2,
      onlyNotConfirmed: true,
    },
    requestPolicy: 'network-only',
  });

  const [bodyShowLists, setBodyShowLists] = useState<BodyShowList[]>([]);

  useEffect(() => {
    if (!noticeList.data) return;
    setBodyShowLists(
      createBodyShowLists(selectedDeliveryType === NotificationDeliverTargetType.Personal, noticeList.data),
    );
  }, [noticeList]);

  useEffect(() => {
    setNoticeListVariables(getNewNoticeListVariables());
    getNotConfirmedNoticeList();
  }, [selectedDeliveryType]);

  const renderNoticeList = () => {
    return (
      <div className="noticeWrapper">
        <List
          headerShowList={getNoticeHeaderShowList(selectedDeliveryType === NotificationDeliverTargetType.Personal)}
          bodyShowLists={bodyShowLists}
          onClick={(index) => {
            if (!noticeList.data?.GetNotificationList?.Data) return;
            const data = noticeList.data.GetNotificationList.Data[index];
            setNoticeId(data?.ID || '');
            setIsOpenModal(true);
          }}
          loading={noticeList.fetching}
        />
        {/* ページネーション */}
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          fetchApi={() => setNoticeListVariables(getNewNoticeListVariables())}
          pageCount={calcTotalPage(noticeList.data?.GetNotificationList?.TotalCount || 1, PAGE_COUNT) || 1}
        />
        <ModalBase
          modalStyle={ModalStyle.confirmModal}
          isOpen={isOpenModal}
          onRequestClose={() => setIsOpenModal(false)}
          children={
            <NoticeDetail
              noticeId={noticeId}
              setIsOpenModal={setIsOpenModal}
              resetNoticeList={() => {
                getNoticeList(getNewNoticeListVariables());
                getNotConfirmedNoticeList();
              }}
            />
          }
        />
      </div>
    );
  };

  return (
    <section className="outletWrapper">
      <div className="centerContent">
        <PageLocationSP />
        <Tabs
          tabLists={[
            { title: '全体へのお知らせ' },
            {
              title: 'あなたへのお知らせ',
              extra:
                notConfirmedNoticeList?.data?.GetNotificationList?.Data &&
                0 < notConfirmedNoticeList.data.GetNotificationList.Data.length ? (
                  <span className="notRead">●</span>
                ) : null,
            },
          ]}
          tabContents={[renderNoticeList(), renderNoticeList()]}
          selectedIndex={selectedDeliveryType - 1}
          onSelect={(index) => {
            setSelectedDeliveryType(index + 1);
            setCurrentPage(1);
          }}
        />
        {/* 顧客リスト */}
      </div>
    </section>
  );
};
